import { useEffect, useState } from "react";

import axiosInstance from "../../utils/axios-instance";

const StatsSetting = () => {
  const [data, setData] = useState<Record<string, any>>({});

  useEffect(() => {
    const GetStats = async () => {
      try {
        const res = await axiosInstance.get("/stats/agency-chat-count");
        setData(res.data);
      } catch (err) {
        console.log(err);
      }
    };

    GetStats();
  }, []);

  return (
    <div className="w-full pb-12 pt-12">
      <div className="w-[92%] md:w-[80%] lg:w-[60%] mx-auto">
        <h2 className="font-display text-2xl text-lightBlack font-semibold tracking-tight">Stats</h2>
        <p className="text-sm text-gray-500 mt-1 mb-6">Quick overview of platform activity.</p>

        <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="bg-white border border-gray-100 rounded-2xl p-6 shadow-soft hover:shadow-card transition-shadow">
            <p className="text-xs text-gray-500 uppercase tracking-wider font-medium mb-3">
              Agencies with at least 1 chat
            </p>
            <h2 className="font-display text-3xl font-semibold text-blue">{data?.agencyChats ?? "—"}</h2>
          </div>
          <div className="bg-white border border-gray-100 rounded-2xl p-6 shadow-soft hover:shadow-card transition-shadow">
            <p className="text-xs text-gray-500 uppercase tracking-wider font-medium mb-3">Total chats</p>
            <h2 className="font-display text-3xl font-semibold text-blue">{data?.totalChats ?? "—"}</h2>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatsSetting;
